module.exports = __webpack_public_path__ + "static/storybooks-5180cc89a19ed8618d33a12f77cd0d74.jpg";